import { types } from './mutations';

export default {
    setPrintWindow({ commit }, data) {
        commit(types.SET_PRINT_WINDOW, data);
    },
};
